import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import AccordionTemplate from "../Wrappers/AccordionTemplate";
import UserAvatar from "../Atoms/Templates/UserAvatar";
import EditTextButton from "../Atoms/Buttons/EditTextButton";
import DeleteTextButton from "../Atoms/Buttons/DeleteTextButton";
import Icon from "../Atoms/Icon";
import SaveTextButton from "../Atoms/Buttons/SaveTextButton";
import CancelTextButton from "../Atoms/Buttons/CancelTextButton";

const PayrollNote = props => {
  const {note, index} = props
  const [isEditable, setIsEditable] = useState(false)
  const contentContainer = useRef()

  const handleEditNote = () => {
    setIsEditable(true)
    setTimeout(() => {
      contentContainer.current.focus()
    }, 0)
  }

  const saveNote = () => {
    setIsEditable(false)
  }

  return (
    <article className={`payroll-note s-mb-0 ${isEditable && 'is-editable'}`}>
      <AccordionTemplate
        dinamicHeight={isEditable}
        index={index}
      >
        <header className="select-none cursor-pointer hover-change s-px-4px small-radius s-main-justify nowrap">
          <p className="title s-mb-0 s-mr-2px padding-transition"
            contentEditable={isEditable}>{note.title}</p>
          <div className="flex-none s-pt-4px">
            <Icon
              className="dropdown-icon"
              svg="down"
              size="12px"
            />
          </div>
        </header>
        <div className="small s-color-lighter-text s-px-4px">
          <div className="s-mb-4px"/>
          <div className="s-mb-4px s-cross-center">
            <div className="s-mr-4px s-mt-2px">
              <UserAvatar/>
            </div>
            <p className="s-mb-0 small s-color-light-text">Evelyn Castrejón</p>
          </div>
          <time className="s-mb-6px s-color-light-text smaller flex">{note.date}</time>
          <div ref={contentContainer}
            className="content s-mb-8px padding-transition"
            contentEditable={isEditable}>
            {note.content}
          </div>
          <footer className="s-cross-center">
            {isEditable ? (
              <>
                <SaveTextButton
                  className="s-mr-4px"
                  onClick={saveNote}
                />
                <CancelTextButton onClick={() => setIsEditable(false)}/>
              </>
            ) : (
              <>
                <EditTextButton
                  onClick={handleEditNote}
                  className="s-mr-4px"
                />
                <DeleteTextButton/>
              </>
            )}
          </footer>
        </div>
      </AccordionTemplate>
    </article>
  );
};

PayrollNote.propTypes = {
  index: PropTypes.number.isRequired,
  note: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
};

export default PayrollNote;
